import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import { router } from "@/routes";
import sourceflowEnums from "@/sourceflow.enums";

export { default } from 'pages/submission-success'

/**
 *
 * @param {object} context
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps(context) {
    const global = (await Global()).toJson();
    const serializableGlobal = JSON.parse(JSON.stringify(global));
    const { params } = context;
    const { url_slug } = params;

    const routerKey = {
        en: router["contact_us.item.thank_you"]["en"].replace("[url_slug]", url_slug),
    };

    return {
        props: {
            global: serializableGlobal,
            meta: {
                title: `Thank you for submission | Tradewind Subs`,
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                // canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                canonical: `${sourceflowEnums.seo.baseURL}${routerKey.en}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            }
        },
    };
}

export async function getStaticPaths() {
    const pagePaths = (await Collection('locations')).getPaths('url_slug');
    // const paths = (await Collection("locations")).getItems();

    return {
        paths: pagePaths,
        fallback: false,
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search